import type { IMediaRecorder } from 'extendable-media-recorder';
import { create } from 'zustand';
import {
  RecorderFileReady,
  type RecorderStartedOutput,
  type StatusMessages,
  createMediaRecorder,
} from '../utils/recorder';

interface RecorderState {
  status: StatusMessages;
  setStatus: (status: StatusMessages) => void;
  startRecording: ({
    onFileReady,
    onProgress,
    micDeviceId,
  }: RecorderFileReady) => Promise<RecorderStartedOutput>;
  stopRecording: () => void;
  mediaRecorder: IMediaRecorder | null;
  setMediaRecorder: (mediaRecorder: IMediaRecorder | null) => void;
  timer: string;
  setTimer: (timer: string) => void;
}

const recorder = createMediaRecorder({
  screen: true,
  audio: true,
  video: true,
});

export const useRecorderState = create<RecorderState>((set) => ({
  status: 'idle',
  setStatus: (status) => set({ status }),
  startRecording: async ({
    onFileReady,
    onProgress,
  }: RecorderFileReady): Promise<RecorderStartedOutput> => {
    const { mediaRecorder, status } = await recorder.startRecording({
      onFileReady,
      onProgress,
    });
    set({ status, mediaRecorder, timer: new Date().toISOString() });
    return { mediaRecorder, status };
  },
  stopRecording: async () => {
    set({ timer: '', status: 'loading' });
    await recorder.stopRecording();
  },
  mediaRecorder: null,
  setMediaRecorder: (mediaRecorder) => set({ mediaRecorder }),
  timer: '',
  setTimer: (timer) => set({ timer }),
}));
